import React from "react";

const CIRCLE_D =
  "M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76536 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51775 9.51009 10.0534 8.7084C10.5891 7.90671 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125Z";

const CHECK_D =
  "M8.14032 5.14031L5.51532 7.76531C5.48049 7.80018 5.43913 7.82784 5.3936 7.84671C5.34808 7.86558 5.29928 7.87529 5.25 7.87529C5.20072 7.87529 5.15192 7.86558 5.1064 7.84671C5.06088 7.82784 5.01952 7.80018 4.98469 7.76531L3.85969 6.64031C3.78932 6.56995 3.74979 6.47451 3.74979 6.375C3.74979 6.27549 3.78932 6.18005 3.85969 6.10969C3.93005 6.03932 4.02549 5.99979 4.125 5.99979C4.22451 5.99979 4.31995 6.03932 4.39031 6.10969L5.25 6.96984L7.60969 4.60969C7.64453 4.57485 7.68589 4.54721 7.73142 4.52835C7.77694 4.5095 7.82573 4.49979 7.875 4.49979C7.92428 4.49979 7.97307 4.5095 8.01859 4.52835C8.06411 4.54721 8.10547 4.57485 8.14032 4.60969C8.17516 4.64453 8.20279 4.68589 8.22165 4.73141C8.24051 4.77694 8.25021 4.82573 8.25021 4.875C8.25021 4.92427 8.24051 4.97306 8.22165 5.01859C8.20279 5.06411 8.17516 5.10547 8.14032 5.14031Z";

export default function TicketStatusOpen12({ className }) {
  return (
    <svg
      className={className}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      focusable="false"
    >
      <path d={CIRCLE_D} fill="#37b450" />
      <path d={CHECK_D} fill="#fff" />
    </svg>
  );
}
